// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__71lqg","label":"styles_label__1v5Ao"};